import { getNetworkApi, updateNetworkApi } from "../components/constant/Api";
import { myApi } from "./api";

export const userApi = myApi.injectEndpoints({
    endpoints: (builder) => ({

        getNetwork: builder.query({
            query: () => {
                return {
                    url: getNetworkApi,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => {
                return response.status ? response : { data: [], total: 0 };
            },
            providesTags: (_) => ["user"],
        }),
        updateNetwork: builder.mutation({
            query: (post) => ({
                url: updateNetworkApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["user"],
        }),

    }),
});

export const { useGetNetworkQuery, useUpdateNetworkMutation } = userApi;